import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import Table from "../../../FlowConfigurationInputs/Table/Table";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';


/**
 * @Description this page Active Directory  Library's   AddUserToGroup  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */

function RemoveUserFromGroup({
  action,
  variables,
  setOpenVariable,
  variableRender,
  automVersionId
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.";
  const headers = [label + "CREATE-USER.USERNAME"];
  const options = {
    tableBody: { headers, title: label + "CREATE-USER.USERS" },
  };
  return (
    <div>
      <div className="form-element">
        <Table
          action={action}
          inputName="users"
          automVersionId={automVersionId}
          options={options.tableBody}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          isActiveDirectory={true}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "ADD-GROUP.GROUP-NAME")} is_required={true} />
        <TextInput
          action={action}
          isRequired={true}
          inputName="groupName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType="string"
          displayName={t(label + "ADD-GROUP.GROUP-NAME")}
          hideRequired={true}
        />
      </div>
    </div>
  );
}

export default RemoveUserFromGroup;
